export const SET_POLL_PROGRAM = 'SET_POLL_PROGRAM';
export const SET_POLL_PROGRAMS = 'SET_POLL_PROGRAMS';
export const SET_CURRENT_PROGRAM = 'SET_CURRENT_PROGRAM';
export const SET_PROGRAMS = 'SET_PROGRAMS';
export const SET_PROGRAM_OPTIONS = 'SET_PROGRAM_OPTIONS';
export const SET_VIEWER = 'SET_VIEWER';